import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-erp',
  imports: [],
  templateUrl: './erp.html',
  styleUrl: './erp.css',
})
export class Erp {
  protected readonly erpAppUrl = environment.erpAppUrl;
}
